import React, { useState } from 'react';
import {
  Alert, AlertTitle, Collapse, Typography,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetWarning/NewWidgetWarning.styles';
import WarningIcon from '@mui/icons-material/Warning';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Typography700 } from 'views/rebranded-module/common/components';
const NewWidgetWarning = (props) => {
  const { alertMessage } = props;
  const [open, setOpen] = useState(true);
  const cmsData = useContent('NewMainWidgetComponent')
  return (
    <StyledBox className="widgetAlert" mb={2}>
      <Collapse in={open}>
        <Alert
          severity="warning"
          onClose={() => {
            setOpen(false);
          }}
          variant="filled"
          icon={<WarningIcon fontSize="small" />}>
          <AlertTitle>
            <Typography700 variant="body2" component="p">
              {cmsData.warning}
            </Typography700>
          </AlertTitle>
          <ul>
            {alertMessage.map((item) => (
              <li>
                <Typography variant="body2" component="p">
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </Alert>
      </Collapse>
    </StyledBox>
  );
};
export { NewWidgetWarning };
